import { makeEnum } from '../util/mappingLib.js';
import { addDisplayedEnum } from './enumCommon.js';
import { InvestmentAccountType } from './investmentAccountConstants.js';

const TransferDirection = addDisplayedEnum(
  {
    INCOMING: 'incoming',
    OUTGOING: 'outgoing',
  },
  'TransferDirection',
);

const TransferRequestCreator = addDisplayedEnum(
  {
    CREATED_BY_USER: 'createdByUser',
    CREATED_BY_RECURRING_DEPOSIT: 'createdByRecurringDeposit',
  },
  'TransferRequestCreator',
);

const TransferStatus = addDisplayedEnum(
  {
    PENDING: 'transferPending',
    PROCESSING: 'transferProcessing',
    COMPLETED: 'transferCompleted',
    CANCELLED: 'transferCancelled',
    FAILED: 'transferFailed',
  },
  'TransferStatus',
);

const DistributionAgeCategory = makeEnum({
  EARLY: 'earlyDistribution', // less than 59.5
  NORMAL: 'normalDistribution', // greater than 59.5
});

const DistributionReason = addDisplayedEnum(
  {
    // Alpaca code: 'normal' - Normal Distribution
    // Alpaca code: 'early_no_exception' - Early distribution, no known exception
    // Alpaca code: 'excess_removal_current_year' - Excess contributions plus earnings/excess deferrals (and/or earnings) taxable in current year
    // Alpaca code: 'excess_removal_current_year_under_59.5' - Removal of Excess Plus Earning/Excess Deferrals Taxable in current yr - < 59.5
    // Alpaca code: 'excess_removal_1_year_prior_over_59.5' - Removal of Excess Plus Earning/Excess Deferrals Taxable in prior year - >59½
    // Alpaca code: 'excess_removal_1_year_prior_under_59.5' - Removal of Excess Plus Earning/Excess Deferrals Taxable in prior year - <59½

    TRADITIONAL_NORMAL_WITHDRAWAL: 'traditionalIraNormalWithdrawal',
    TRADITIONAL_EARLY_WITHDRAWAL_NO_EXCEPTION: 'traditionalIraEarlyWithdrawalNoException',
    TRADITIONAL_NORMAL_EXCESS_REMOVAL_CURRENT_YEAR: 'traditionalIraNormalExcessRemovalCurrentYear',
    TRADITIONAL_EARLY_EXCESS_REMOVAL_CURRENT_YEAR: 'traditionalIraEarlyExcessRemovalCurrentYear',
    TRADITIONAL_NORMAL_EXCESS_REMOVAL_PRIOR_YEAR: 'traditionalIraNormalExcessRemovalPriorYear',
    TRADITIONAL_EARLY_EXCESS_REMOVAL_PRIOR_YEAR: 'traditionalIraEarlyExcessRemovalPriorYear',

    // Alpaca code: 'normal_roth' - Qualified distribution from a Roth IRA (IRA 5-year holding period has been reached and customer is over 59½, or is dead, or is disabled)
    // Alpaca code: 'early_roth_no_exception' - Early distribution from a Roth IRA, no known exception (when Code T or Code Q do not apply)
    // Alpaca code: 'excess_removal_roth' - Removal of Excess from a Roth IRA
    // Alpaca code: 'excess_removal_1_year_prior_roth' - Excess contributions plus earnings in prior year - Roth IRA

    ROTH_NORMAL_WITHDRAWAL: 'rothIraNormalWithdrawal',
    ROTH_EARLY_WITHDRAWAL_NO_EXCEPTION: 'rothIraEarlyWithdrawalNoException',
    ROTH_EXCESS_REMOVAL_CURRENT_YEAR: 'rothIraExcessRemovalCurrentYear',
    ROTH_EXCESS_REMOVAL_PRIOR_YEAR: 'rothIraExcessRemovalPriorYear',
  },
  'DistributionReason',
);

const { TRADITIONAL, ROTH } = InvestmentAccountType;
const { EARLY, NORMAL } = DistributionAgeCategory;

const DistributionReasonsByAccountTypeAndAgeCategory = {
  [TRADITIONAL]: {
    [NORMAL]: [
      DistributionReason.TRADITIONAL_NORMAL_WITHDRAWAL,
      DistributionReason.TRADITIONAL_NORMAL_EXCESS_REMOVAL_CURRENT_YEAR,
      DistributionReason.TRADITIONAL_NORMAL_EXCESS_REMOVAL_PRIOR_YEAR,
    ],
    [EARLY]: [
      DistributionReason.TRADITIONAL_EARLY_WITHDRAWAL_NO_EXCEPTION,
      DistributionReason.TRADITIONAL_EARLY_EXCESS_REMOVAL_CURRENT_YEAR,
      DistributionReason.TRADITIONAL_EARLY_EXCESS_REMOVAL_PRIOR_YEAR,
    ],
  },
  [ROTH]: {
    [NORMAL]: [
      DistributionReason.ROTH_NORMAL_WITHDRAWAL,
      DistributionReason.ROTH_EXCESS_REMOVAL_CURRENT_YEAR,
      DistributionReason.ROTH_EXCESS_REMOVAL_PRIOR_YEAR,
    ],
    [EARLY]: [
      DistributionReason.ROTH_EARLY_WITHDRAWAL_NO_EXCEPTION,
      DistributionReason.ROTH_EXCESS_REMOVAL_CURRENT_YEAR,
      DistributionReason.ROTH_EXCESS_REMOVAL_PRIOR_YEAR,
    ],
  },
};

export {
  TransferDirection,
  TransferRequestCreator,
  TransferStatus,
  DistributionAgeCategory,
  DistributionReason,
  DistributionReasonsByAccountTypeAndAgeCategory,
};
